
import React, { useState, useEffect } from 'react';
import CustomSnackbar from '../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {Button} from '@mui/material';
import Select from 'react-select';
import { SearchSubwaysCanton } from '../../UpdatingOptic/LoadingDataOptic';
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';
import ModalStatisticSubwayDescription from './StatisticMadal/ModalStatisticSubwayDescription';

//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const StatisticSubwaysCanton = (user) => {

    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
    const [optics, setOptics] = useState([]);
    const [error, setError] = useState('');
    const [selectedCable, setSelectedCable] = useState(null); 
    const [openVewingModal,  setOpenVewingModal] = useState(false); 
    const [searchQuery, setSearchQuery] = useState("");
    const [canton, setCanton] = useState([]);
    const [selectedCanton, setSelectedCanton] = useState('');
    

     useEffect(() => {
        loadingCanton(setCanton); 
      }, []); 

    const filteredOptics = optics.map(optic => {
        const matchingRows = optic.rows.filter(row =>
          row.region && String(row.region).trim() !== '' &&
          (searchQuery === '' || String(row.region).includes(searchQuery))
        );
        return matchingRows.length > 0 ? { ...optic, matchingRows } : null;
      }).filter(Boolean);

      

    const searchOptic = async () => {
        SearchSubwaysCanton(selectedCanton, setOptics, setError);
        setSearchQuery('');
        
    };
    const handleRowClick = (cable) => {
       setSelectedCable(cable);
       setOpenVewingModal(true);
    };

    // useEffect(() => {
    //         SearchRegionOptic(region, setOptics, setHouses, setError); 
    // }, [openVewingModal]);

    const copyToClipboard = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.focus(); 
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            showSnackbar('Скопировано: ID: ' + text, 'snackbarOk');
          } else {
            showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
          }
        } catch (err) {
          showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
        }
        document.body.removeChild(textarea);
      };
     
    const totalAddresses = filteredOptics.length;
    const totalActualized = filteredOptics.filter(address => address.status).length;
    const totalNoCoordinates = totalAddresses - totalActualized;

    return (
      <div className="updating-territory">
      <h3 style={{color: "#a1a1a1", fontSize: "20px" , textShadow: '2px 2px 4px #000000'}}>Подземки на округе</h3>
      <div className="flex-container">
          <div style={{ display: "flex", alignItems: "center", gap: "10px",marginBottom: "15px" }}>
             
          <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={searchOptic} 
          >
            Загрузить
          </button>
          {selectedCanton && (
            <>
              <div className="address-summary">
                 <label style={{color: "#c5c5c5", textShadow: '2px 2px 4px #242424', fontSize: '14px'}}>Всего подземок: <span style={{color: "orange"}}>{totalAddresses}.</span></label>
              </div>
              <input 
                type="number" 
                placeholder="поиск по региону" 
                value={searchQuery} 
                className='textInputPoiskModal'
                onChange={(e) => setSearchQuery(e.target.value)} 
                style={{ marginLeft: '20px' }}
              />
            </>
          )}
              
          </div>
         
        
      </div>
      <hr className='horizontalLine12Modal'/>
            {error && <p style={{ color: '#e9d7d7' }}>{error}</p>}
            {filteredOptics.length > 0 && (
            <div className="table-container-subway" style={{marginTop:'10px'}}>
                <table className="address-table1" >
                    <thead>
                        <tr>
                            <th>ID</th>             
                            <th>Округ</th>
                            <th>Регион</th>
                            <th>Ветка</th>
                            <th>Тип</th>
                            <th>Марка</th>
                            <th>Длина</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Коммент</th>
                            <th>Создал</th>
                        </tr>
                    </thead>
                    <tbody>


                   
        {filteredOptics.map((optic, index) => {
             const firstRowWithArea = optic.matchingRows.find(row => row.area && row.area !== 0);

            return firstRowWithArea ? (
                <tr 
                    key={firstRowWithArea.id} 
                    className={optic.status ? 'status-actualized1' : 'status-no-coordinates1'}
                    onClick={() => handleRowClick(optic)}
                >
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>
                        {optic.highwayLineId}
                        <Button 
                            style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                            onClick={(e) => {
                                e.stopPropagation(); 
                                copyToClipboard(optic.highwayLineId);
                            }}
                        >
                            <FileCopyIcon style={{ color: '#e0920b' }} />
                        </Button>           
                    </td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.canton}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.region}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.area}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424',  fontSize: "12px"}}>{firstRowWithArea.cableType}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.cableName}</td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.lengthCable} м.</td>
                 <td
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                    fontSize: "12px"
                    }}  
                  >
                    {
                      firstRowWithArea.streetStart || firstRowWithArea.houseStart || firstRowWithArea.entranceStart
                        ? `${firstRowWithArea.streetStart ?? ''} д.${firstRowWithArea.houseStart ?? ''} под.${firstRowWithArea.entranceStart ?? ''}`
                        : 'нет'
                    }
                  </td>

                 <td
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                      fontSize: "12px"
                    }}
                  >
                    {
                      firstRowWithArea.streetEnd || firstRowWithArea.houseEnd || firstRowWithArea.entranceEnd
                        ? `${firstRowWithArea.streetEnd ?? ''} д.${firstRowWithArea.houseEnd ?? ''} под.${firstRowWithArea.entranceEnd ?? ''}`
                        : 'нет'
                    }
                  </td>

                    <td  style={{
                      maxWidth: '450px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                      fontSize: "12px"
                    }}>
                      {firstRowWithArea.description}
                    </td>
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>{firstRowWithArea.authorId}</td>
                   
                </tr>
            ) : null;
        })}



        {/* для кретичносты */}
     {/* {filteredOptics.map((optic, index) => {
             const firstRowWithArea = optic.matchingRows.find(row => row.area && row.area !== 0);

            return firstRowWithArea ? (
                <tr 
                    key={firstRowWithArea.id} 
                    className={optic.status ? 'status-actualized1' : 'status-no-coordinates1'}
                    onClick={() => handleRowClick(optic)}
                >
                    <td style={{ textShadow: '2px 2px 4px #242424'}}>
                       ВОЛЗ-{optic.highwayLineId}
                              
                    </td>
                  
                   
                   
                 <td
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      textShadow: '2px 2px 4px #242424',
                      padding: '5px',
                    fontSize: "12px"
                    }}  
                  >
                    {
                      firstRowWithArea.streetStart || firstRowWithArea.houseStart || firstRowWithArea.entranceStart
                        ? `${firstRowWithArea.streetStart ?? ''} д.${firstRowWithArea.houseStart ?? ''} под.${firstRowWithArea.entranceStart ?? ''}`
                        : 'нет'

                        
                    }
                     -
                     {
                      firstRowWithArea.streetEnd || firstRowWithArea.houseEnd || firstRowWithArea.entranceEnd
                        ? `${firstRowWithArea.streetEnd ?? ''} д.${firstRowWithArea.houseEnd ?? ''} под.${firstRowWithArea.entranceEnd ?? ''}`
                        : 'нет'
                    }
                  </td>

                   <td style={{ textShadow: '2px 2px 4px #242424' }}>
                      {(firstRowWithArea.lengthCable / 1000).toFixed(3)} 
                    </td>


                 
                </tr>
            ) : null;
        })}  */}

                    </tbody>
                </table>
            </div>      
         )} 

                {openVewingModal && selectedCable && (
                   <ModalStatisticSubwayDescription
                    open={openVewingModal} 
                    onClose={() => setOpenVewingModal(false)}
                    context={selectedCable} 
                    user={user}
                   /> 
                )}

                  {/* Snackbar */}
                    <Snackbar
                         anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'left',
                         }}
                         open={snackbarOpen}
                         autoHideDuration={3000}
                         onClose={handleCloseSnackbar}
                         message={snackbarMessage}
                         ContentProps={{
                          style: {
                            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                          }
                        }}
                      />            
        </div>
    );
};

export default StatisticSubwaysCanton;